<!--
 * @created on 2018/11/13
 * @author LaiXinYu <laixinyualex@gmail.com>
-->

<template>
    <transition name="zoom">
        <div class="disclaimer" v-if="open">
            <div class="content">
                <div class="title">免责声明</div>
                <p>用户在接受本平台服务之前，请务必仔细阅读并同意本声明。用户在【旅喵结伴】平台的发起的任何行为以及通过各类方式利用本平台的行为，都将被视作是对本声明全部内容的无异议的认可。声明如下：</p>
                <p>1、【旅喵结伴】用户需具备完全民事行为能力，若发现用户不具备完全民事行为能力，【旅喵结伴】有权注销该个人账户。</p>
                <p>2、【旅喵结伴】用户在从事与本平台相关的所有行为（包括但不限于访问浏览、利用、转载、宣传介绍），需遵守中国有关法律、法规的规定，否则，【旅喵结伴】有权对相关账户进行封停或禁言处理，并提交相关部门进行处理。</p>
                <p>3、用户不得在【旅喵结伴】上发布与旅游行程无关的信息。</p>
                <p>4、【旅喵结伴】平台发布的行程信息由用户提供，【旅喵结伴】仅作为一个展示结伴旅游信息的平台，不收取用户任何费用，【旅喵结伴】不保证用户所发布信息的真实性、准确性或可靠性，用户应自身进行独立判断，避免因信赖此类信息而导致人身或财产上的损害。</p>
                <p>5、温馨提示：用户在结伴旅游过程中，请注意提高风险防范意识，保障出游安全。</p>
                <p>6、若用户发现其他用户通过【旅喵结伴】平台发布不实信息或存在其他违法行为，可举报至邮箱：travelmate@zuzuche.com，【旅喵结伴】将及时进行处理。</p>
            </div>

            <div class="btn" @click="handleClose">我知道了</div>
        </div>
    </transition>

</template>

<style scoped lang="scss">
@import "../../style/config";
@import "../../style/function";

.disclaimer {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    z-index: 1001;
}

.content {
    flex: 1;
    overflow: scroll;
    padding: px2rem(40) px2rem(30);
    box-sizing: border-box;
}

.title {
    text-align: center;
    font-weight: bold;
    font-size: px2rem(38);
    line-height: 1.5;
}

p {
    font-size: px2rem(24);
    line-height: 1.5;
    padding-bottom: 1em;
}

.btn {
    display: flex;
    justify-content: center;
    align-items: center;
    background: $btnColor;
    color: #fff;
    width: 100%;
    font-size: px2rem(28);
    height: px2rem(80);
}
</style>

<script>
export default {
    name: "Disclaimer",
    props: {
        open: true
    },
    data() {
        return {};
    },
    methods: {
        handleClose() {
            this.$emit("close");
        }
    }
};
</script>
